import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AddCardForm from '../PaymentCard/addcard';

const AddCardModal = ({ isOpen, onClose, onCardAdded }) => {
  const { t } = useTranslation('modals');
  if (!isOpen) return null;

  const handleSuccess = (cardData) => {
    onCardAdded?.(cardData);
    onClose();
  };

  return createPortal(
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-[110] p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white dark:bg-[#1a1a22] rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-white/10 flex-shrink-0">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{t('addCard.title')}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors p-1 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Card Form */}
        <div className="overflow-y-auto flex-1">
          <AddCardForm onSuccess={handleSuccess} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddCardModal;
